import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IntroStep from './Components/IntroStep'
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import './index.scss';
import { reportScreen } from '../../services/analyticsService';

const ResumeBuilder = () => {
    const { resumeId } = useParams();
    const [resume, setResume] = useState()

    const dispatch = useDispatch()
    useEffect(() => {
        reportScreen('resume_builder_create')
    }, [])
    useEffect(() => {
        if (!resume) {
            dispatch(push(`/resume-builder/create`))
        }
    }, [resumeId, resume, dispatch]);

    return <IntroStep setResume={setResume} />

};

export default ResumeBuilder; 